<template>
	<div
		:class="[
			buttonStyle ?? blok?.style,
			buttonHeight ?? blok?.height,

			'button cursor-pointer flex items-center justify-center px-5 '
		]"
	>
		<NuxtLink
			v-if="blok"
			:to="
				link
					? localePath(link)
					: blok.button_link.story
						? localePath(`/${blok.button_link.story.full_slug}`)
						: localePath(blok.button_link.cached_url)
			"
			:class="[blok.text_size, `transition-all text-base button`]"
		>
			{{ blok.button_text }}
			<slot />
		</NuxtLink>
		<NuxtLink
			v-else-if="link"
			:to="localePath(link)"
			:class="[textSize, `transition-all text-base w-full text-center button`]"
		>
			{{ text }}
			<slot />
		</NuxtLink>
		<button
			v-else
			:class="[textSize, `transition-all text-base w-full text-center button`]"
		>
			{{ text }}
		</button>
	</div>
</template>

<script setup lang="ts">
import type { BlokButton } from "~/types/storyblok/storyblok";

interface Props {
	blok?: BlokButton;
	link?: string;
	textSize?: string;
	buttonStyle?: string;
	text?: string;
	buttonHeight?: string;
}

const { blok, link, textSize, buttonStyle, text, buttonHeight } =
	defineProps<Props>();

const localePath = useLocalePath();
</script>
